class DuplicateWalletTemplateWorkflow {
    constructor($injector) {
        this.injector = $injector;
        this.state = this.injector.get('$state');
        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');

        this.key = 'download-passbook';
        this.title = this.translate.instant('wallets.templates.workflows.details.duplicate');
        this.level = 'highlight';
        this.icon = 'copy';
    }

    action(template, vm) {
        this.api
            .post(`wallets/templates/${template.id}/duplicate`)
            .then(({data}) => {
                this.alert.success(
                    this.translate.instant('general.alerts.duplication_success.title'),
                    this.translate.instant('general.alerts.duplication_success.content'),
                )
                this.state.go('app.wallets.templates.details', {
                    id: data.data.id
                });
            })
            .catch(err => {
                this.alert.error(
                    this.translate.instant('general.alerts.duplication_error.title'),
                    this.translate.instant('general.alerts.duplication_error.content'),
                )
            });
    }

}

angular
    .module('festzelt-os.modules.wallets.templates')
    .factory('duplicatePassbook', [
        '$injector',
        ($injector) => new DuplicateWalletTemplateWorkflow($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/workflows/details/duplicate.js